var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLightSave({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09049 19.3195H14.0905V17.6528H4.09049V7.65283H2.42383V17.6528C2.42383 18.572 3.17133 19.3195 4.09049 19.3195Z",
    fill: "white",
    fillOpacity: 0.98
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4245 2.65283H7.42448C6.50531 2.65283 5.75781 3.40033 5.75781 4.3195V14.3195C5.75781 15.2387 6.50531 15.9862 7.42448 15.9862H17.4245C18.3436 15.9862 19.0911 15.2387 19.0911 14.3195V4.3195C19.0911 3.40033 18.3436 2.65283 17.4245 2.65283ZM15.7578 10.1528H13.2578V12.6528H11.5911V10.1528H9.09115V8.48617H11.5911V5.98617H13.2578V8.48617H15.7578V10.1528Z",
    fill: "white",
    fillOpacity: 0.98
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLightSave);
export default __webpack_public_path__ + "static/media/lightSave.b1310ae8ee41d14dc44864f3f5566d2f.svg";
export { ForwardRef as ReactComponent };